module.exports = __webpack_public_path__ + "static/img/preview-04.6f3bf826.webp";